module.exports = "/src/views/player/help/images/lawn.jpg";